<template>
  <div class="wrapper">
    <h1 style="text-align: center">
      {{ detail.projectName ? detail.projectName : "" }}工程成本明细表
    </h1>
    <div class="table-title">
      <p>项目所属年度：{{ detail.projectYear ? detail.projectYear : "" }}</p>
      <p>{{ detail.createTime ? detail.createTime : "" }}</p>
      <p>单位：元</p>
    </div>
    <div class="table-wrapper">
      <div class="table-top">
        <div>
          合同金额：{{
            formatMoneyNumber(detail.contractAmount)
          }}元&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div>
          已完成工作量：{{
            formatMoneyNumber(detail.finishPriceSum)
          }}元&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div>
          上报计量：{{
            formatMoneyNumber(detail.calculatePriceSum)
          }}元&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div>
          已收计量金额：{{
            formatMoneyNumber(detail.receiptPriceSum)
          }}元&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div>
          收集团拨款金额：{{
            formatMoneyNumber(detail.groupAmount)
          }}元&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div>资金成本：{{ formatMoneyNumber(detail.capitalCost) }}元</div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :span-method="spanArrayMethod"
        height="500"
      >
        <el-table-column
          label="项目"
          prop="title"
          fixed
          width="200"
        ></el-table-column>
        <el-table-column
          label="序号"
          prop="myindex"
          fixed
          width="50"
        ></el-table-column>
        <el-table-column label="合作单位" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row && scope.row.partyBSpecial">
              <div class="department-comments">
                <p>委派主办会计：</p>
                <p>计划部负责人：</p>
                <p>工程部负责人：</p>
                <p>材料部负责人：</p>
                <p>制表人：</p>
              </div>
            </div>
            <div v-else>{{ scope.row.partyB }}</div>
          </template>
        </el-table-column>
        <el-table-column label="合同编号" width="200" prop="serialNumber">
        </el-table-column>
        <el-table-column label="合同金额（含税）" width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.amount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="合同内容" prop="contractContent" width="200">
        </el-table-column>
        <el-table-column label="税后合价" width="200">
          <template slot-scope="scope">
            <div v-if="!scope.row.contractContentSpecial">
              {{ formatMoneyNumber(scope.row.settleAmount) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="裸税合价" width="200">
          <template slot-scope="scope">
            <div v-if="!scope.row.contractContentSpecial">
              {{ formatMoneyNumber(scope.row.cost) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="开具发票">
          <el-table-column label="含税金额" width="200">
            <template slot-scope="scope">
              <div v-if="!scope.row.contractContentSpecial">
                {{ formatMoneyNumber(scope.row.taxBillAmount) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="不含税金额" width="200">
            <template slot-scope="scope">
              <div v-if="!scope.row.contractContentSpecial">
                {{ formatMoneyNumber(scope.row.noTaxBillAmount) }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="未开具发票">
          <el-table-column label="含税金额" width="200">
            <template slot-scope="scope">
              <div v-if="!scope.row.contractContentSpecial">
                {{ formatMoneyNumber(scope.row.taxNoBillAmount) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="暂行税率" width="200">
            <template slot-scope="scope">
              <div v-if="!scope.row.contractContentSpecial">
                {{ formatPercentNumber(scope.row.taxRateCurrent) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="不含税金额" width="200">
            <template slot-scope="scope">
              <div v-if="!scope.row.contractContentSpecial">
                {{ formatMoneyNumber(scope.row.noTaxNoBillAmount) }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="累计已付款" width="200">
          <template slot-scope="scope">
            <div v-if="!scope.row.contractContentSpecial">
              {{ formatMoneyNumber(scope.row.alreadyPay) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尚欠款" width="200">
          <template slot-scope="scope">
            <div v-if="!scope.row.contractContentSpecial">
              {{ formatMoneyNumber(scope.row.debtAmount) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="已付款比例" width="200">
          <template slot-scope="scope">
            <div v-if="!scope.row.contractContentSpecial">
              {{ formatPercentNumber(scope.row.alreadyPayPct) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="本次拟付款" width="200">
          <template slot-scope="scope">
            <div v-if="!scope.row.contractContentSpecial">
              {{ formatMoneyNumber(scope.row.thisPay) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="再付款比例" width="200">
          <template slot-scope="scope">
            <div v-if="!scope.row.contractContentSpecial">
              {{ formatPercentNumber(scope.row.thisPayPct) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="200">
          <template slot-scope="scope">
            <div v-if="!scope.row.contractContentSpecial">
              {{ scope.row.remark }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-bottom-control">
      <el-button v-if="approveStatus && approveStatus != 2" type="primary" @click="previewHandler">打印</el-button>
      <el-button type="primary" @click="exportData">导出</el-button>
      <el-button type="info" @click="closePage">关闭</el-button>
    </div>
    <el-dialog
      title="预览"
      :visible="dialogVisible"
      width="80%"
      @close="dialogClosed"
    >
    <!-- 默认会去渲染这个dialog，只是不显示。但这样就会访问detail中的数据，而此时detail只是个默认的空对象，并没有数据 -->
      <div id="projectCostDetailTablePrint" v-if="detail && detail.projectManagementCost">
        <h1 style="text-align: center">
          {{ detail.projectName ? detail.projectName : "" }}工程成本明细表
        </h1>
        <div class="table-title">
          <p>
            项目所属年度：{{ detail.projectYear ? detail.projectYear : "" }}
          </p>
          <p>{{ detail.createTime ? detail.createTime : "" }}</p>
          <p>单位：元</p>
        </div>
        <div class="table-top">
          <div>
            合同金额：{{
              formatMoneyNumber(detail.contractAmount)
            }}元&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div>
            已完成工作量：{{
              formatMoneyNumber(detail.finishPriceSum)
            }}元&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div>
            上报计量：{{
              formatMoneyNumber(detail.calculatePriceSum)
            }}元&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div>
            已收计量金额：{{
              formatMoneyNumber(detail.receiptPriceSum)
            }}元&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div>
            收集团拨款金额：{{
              formatMoneyNumber(detail.groupAmount)
            }}元&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div>资金成本：{{ formatMoneyNumber(detail.capitalCost) }}元</div>
        </div>
        <div>
          <table
            style="
              width: 100%;
              border: 1px solid black;
              table-layout: fixed;
              border-collapse: collapse;
            "
          >
            <thead>
              <tr style="text-align: left; border-bottom: 1px solid black">
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">项目</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">序号</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">合作单位</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">合同内容</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">税后合价</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">裸税合价</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">累计已付款</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">尚欠款</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">已付款比例</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">本次拟付款</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">再付款比例</div>
                </th>
                <th style="border-right: 1px solid black">
                  <div style="padding: 12px 4px">备注</div>
                </th>
              </tr>
            </thead>
            <tbody>
               <!-- 劳务费 -->
               <tr style="border-bottom: 1px solid black" v-for="(item,index) in printData" :key="index">
                <td
                  style="padding: 12px 4px; border-right: 1px solid black"
                  :rowspan="item.rowspan" v-if="item.myindex==1||item.partyB=='工料机合计'||item.partyB=='间接费合计'||item.partyB=='合计'"
                >
                  <div >{{item.title}}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ item.myindex}}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black;word-break: break-all;">
                  <div v-if="item.partyBSpecial">
                    <div
                      style="
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                      "
                    >
                      <p>委派主办会计：</p>
                      <p>计划部负责人：</p>
                      <p>工程部负责人：</p>
                      <p>材料部负责人：</p>
                      <p>制表人：</p>
                    </div>
                  </div>
                  <div >{{ item.partyB }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div>{{ item.contractContent }}</div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div
                    v-if="!item.contractContentSpecial"
                  >
                    {{
                      formatMoneyNumber(
                        item.settleAmount
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div
                    v-if="!item.contractContentSpecial"
                  >
                    {{ formatMoneyNumber(item.cost) }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div
                    v-if="!item.contractContentSpecial"
                  >
                    {{
                      formatMoneyNumber(item.alreadyPay)
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div
                    v-if="!item.contractContentSpecial"
                  >
                    {{
                      formatMoneyNumber(item.debtAmount)
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div
                    v-if="!item.contractContentSpecial"
                  >
                    {{
                      formatPercentNumber(
                        item.alreadyPayPct
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div
                    v-if="!item.contractContentSpecial"
                  >
                    {{
                      formatMoneyNumber(item.thisPay)
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div
                    v-if="!item.contractContentSpecial"
                  >
                    {{
                      formatPercentNumber(
                        item.thisPayPct
                      )
                    }}
                  </div>
                </td>
                <td style="padding: 12px 4px; border-right: 1px solid black">
                  <div
                    v-if="!item.contractContentSpecial"
                  >
                    {{ item.remark }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h2 style="margin-top: 15px;">审批信息</h2>
          <div>
            <table
              style="
                width: 100%;
                border: 1px solid black;
                table-layout: fixed;
                border-collapse: collapse;
              "
            >
              <thead>
                <tr style="text-align: left; border-bottom: 1px solid black">
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">序号</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">员工名称</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">岗位名称</div>
                  </th>
                  <th style="border-right: 1px solid black">
                    <div style="padding: 12px 4px">相关意见</div>
                  </th>
                  <th>
                    <div style="padding: 12px 4px">当前状态</div>
                  </th>
                  <th>
                    <div style="padding: 12px 4px">时间</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-if="approveData && approveData.length > 0">
                  <tr
                    v-for="(item, index) in approveData"
                    :key="index"
                    style="border-bottom: 1px solid black"
                  >
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ index + 1 }}
                      </div>
                    </td>

                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ item.approveUserName }}
                      </div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ item.jobName }}
                      </div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div>
                        {{ item.opinion }}
                      </div>
                    </td>
                    <td style="padding: 12px 4px">
                      <div>
                        {{ item.statusName }}
                      </div>
                    </td>
                    <td style="padding: 12px 4px">
                      <div>
                        {{ item.updateTime }}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr style="border-bottom: 1px solid black">
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                    <td
                      style="padding: 12px 4px; border-right: 1px solid black"
                    >
                      <div></div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div style="margin-top: 16px; text-align: center">
        <el-button type="primary" @click="printHandler">打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatMoney, formatPercent } from "./utils";
import { formatProjectCostDetailTableData ,formatEarningCostBasicTable1Data} from "./EarningHelper";
import printJS from "print-js";
import { queryApproveHistoryApi } from "../../services/financeService";
import Constants from "../../utils/consts";
/**
 * 工程成本明细表
 */
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    id: {
      type: [String, Number],
      default: "",
    },
    approveStatus: {
      type: [String, Number],
      default: "",
    },
    closefn: {
      type: Function
    }
  },
  computed: {
    tableData: function () {
      let _data = formatProjectCostDetailTableData(this.detail);
      // console.log("处理好之后的数据", _data);
      return _data;
    },
    printData: function () {
      let _data = formatEarningCostBasicTable1Data(this.detail);
      // console.log("处理好之后的数据", _data);
      return _data;
    },
  },
  data() {
    return {
      previewBtnLoading: false,
      dialogVisible: false,
      approveData: [],
      // printData:[],
    };
  },
  methods: {
    formatMoneyNumber: formatMoney,
    formatPercentNumber: formatPercent,
    spanArrayMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan,
        };
      }
      if (columnIndex == 2) {
        if (row.partyBSpecial) {
          
          return {
            rowspan: row.partyBSpecialRowspan,
            colspan: row.partyBSpecialColumnspan,
          };
        }
      }
      if (columnIndex == 3) {
        if (row.contractContentSpecial) {
          return {
            rowspan: row.contractContentRowspan,
            colspan: row.contractContentColumnspan,
          };
        }
      }
    },
    exportData() {
      this.$emit("export-click", 4);
    },
    closePage() {
      if(this.closefn) {
        this.closefn()
        return
      }
      this.bus.$emit("tabClose", "incomingConstDetail");
      this.bus.$emit("navMenuChange", {
        routeId: "incomeConstList",
      });
    },
    previewHandler() {
      this.previewBtnLoading = true;

      queryApproveHistoryApi({
        approveClass: "EARNING_COST",
        itemId: this.id,
      })
        .then((res) => {
          console.log("----回报", res);
          if (res.code == Constants.Code_OK) {
            this.approveData = res.data || [];
            setTimeout(() => {
              this.dialogVisible = true;
            }, 0);
          } else {
            this.previewBtnLoading = false;
          }
        })
        .catch((error) => {
          console.log("----error", error);
          this.previewBtnLoading = false;
        });
    },
    printHandler() {
      printJS({
        printable: "projectCostDetailTablePrint",
        type: "html",
        targetStyles: ["*"],
        ignoreElements: ["no-print", "bc", "gb"],
        scanStyles: false,
      });
    },
    dialogClosed() {
      this.previewBtnLoading = false;
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 16px;
  box-sizing: border-box;
}

.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

.table-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: none;
  border-bottom: 1px solid#EBEEF5;
  padding: 20px 10px;
  box-sizing: border-box;
  background: #f5f7fa;
}

.department-comments {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  p {
    margin-right: 100px;
  }
}

.page-bottom-control {
  text-align: center;
  padding: 20px 0;
}
</style>
